import React, { useEffect, useState, useMemo } from "react";
import Container from "../components/Layout/Container";
import ContentBlock from "../components/Layout/ContentBlock";
import FilterMenu from "../components/Layout/FilterMenu";
import { message, Tabs } from "antd";
import { IconRefresh, IconCloudSync } from "../components/Layout/Icons";
import { useDispatch, useSelector } from "react-redux";
import { onFilterUpdateWithUser } from "../redux/Actions/filtersAction";
import ModalSimple from "../components/Layout/Modals/ModalSimple";
import CategoryFilterModal from "../components/orders/accepted_orders/Modals/categoryFilterModal";
import { createConsumer } from "@rails/actioncable";
import { antdAsyncMessageSuccess } from "../helpers/AsyncMessage";
import ModalImumCategorySettings from "../components/RetailScreen/ModalImumCategorySettings";
import RetailRules from "../components/RetailScreen/RetailRules";
import RetailExport from "../components/RetailScreen/RetailExport";
import {
  DEFAULT_IMUM_PER_PAGE,
  DEFAULT_IMUM_RULES_PER_PAGE,
  DEFAULT_PER_PAGE,
} from "../helpers/default";
import useFetch from "../hooks/useFetch";
import useInterval from "../hooks/useInterval";
import ImumTrackingCategories from "../components/RetailScreen/ImumTrackingCategories";
import RetailStatistics from "../components/RetailScreen/RetailStatistics";
import RetailCostReview from "../components/RetailScreen/RetailCostReview";
import {
  QueryClient,
  QueryClientProvider,
} from "react-query";

export const queryClient = new QueryClient();
export default function RetailPricingScreen({ match, record_type }) {
  window.identifier = record_type;
  const dispatch = useDispatch();
  const user_id = useSelector((state) => state.auth.user.id);
  const [modal, setModal] = useState(null);
  const [tabId, setTabId] = useState(1);
  const [page, setPage] = useState(1);
  const [totals, setTotals] = useState(0);
  const [perPage, setPerPage] = useState(DEFAULT_PER_PAGE);
  const [length, setLength] = useState(0);

  console.log(length, "length");
  console.log(totals, "totals");
  useEffect(() => {
    const consumer = createConsumer();
    const subscription = consumer.subscriptions.create(
      { channel: "RetailChannel" },
      {
        connected() {
          console.log("Connected WS RetailChannel!");
        },
        received(data) {
          console.log("WebSocket: ", data);
          if (
            [
              "mass_change_price",
              "export_to_pim",
              "mass_new_price_change_by_countries",
              "disable_channel_price_scope",
            ].includes(data?.type)
          ) {
            if (data?.data?.user_id == user_id) {
              // console.log(filters);
              console.log("WEBSOCKET CALLED");
              dispatch({
                type: "LOADING_RETAIL",
              });
              // TODO: kazka sugalvoti!!
              // onFilter(true);
              antdAsyncMessageSuccess({ key: data?.type });
            }
          }
        },
      }
    );
    return () => {
      console.log("WEBSOCKET: unsubscribe");
      subscription.unsubscribe();
    };
  }, [user_id]);

  useEffect(() => {
    dispatch({
      type: "LOADING_RETAIL",
    });
  }, [tabId]);

  const [costReviewRefetch, setCostReviewRefetch] = useState(0);

  const tabRender = useMemo(
    () => [
      {
        key: "1",
        label: "Export page",
      },
      {
        key: "2",
        label: <NotExportedLabel active={tabId == "2"} />,
      },
      {
        key: "6",
        label: (
          <CountedLabel
            active={tabId == "6"}
            title="Cost review"
            url="/api/v1/retail_cost_reviews/total_pending"
            refetchKey={costReviewRefetch}
          />
        ),
      },
      {
        key: "3",
        label: "Rules",
      },
      {
        key: "4",
        label: "Tracking categories",
      },
      {
        key: "5",
        label: "Statistics",
      },
    ],
    [tabId, costReviewRefetch]
  );

  return (
    <Container
      location={{
        locationName: "Retail",
        locationUrl: match.url,
      }}
      breadcrumbs={[
        {
          label: "Retail",
          value: "#",
        },
        {
          label: "Retail pricing",
          value: match.url,
        },
      ]}
    >
      {tabId == 5 ? (
        <div
          style={{
            backgroundColor: "#FFF",
            paddingTop: 16,
            paddingBottom: 16,
            marginLeft: 15,
            marginRight: 15,
            boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
            borderRadius: "0.25rem",
          }}
        >
          <FilterMenu
            length={length}
            text2={`exports`}
            onChangeCountPage={setPerPage}
            countPage={perPage}
            iconComponent={
              <IconCloudSync className="mr-2" width={28} height={22} />
            }
            page={page}
            totals={totals}
          />
        </div>
      ) : (
        <TopNav page={page} setModal={setModal} />
      )}
      <div className="col-12">
        <Tabs
          className="mx-2 text-base"
          value={tabId}
          items={tabRender}
          onChange={(value) => {
            setTabId(value);
            setPage(1);
          }}
        />
        {tabId == 1 ? (
          <RetailExport
            page={page}
            setPage={setPage}
            failed={false}
            record_type={record_type}
            modal={modal}
            totalLength={length}
          />
        ) : tabId == 2 ? (
          <RetailExport
            page={page}
            setPage={setPage}
            failed={true}
            record_type={record_type}
            modal={modal}
            totalLength={length}
          />
        ) : tabId == 6 ? (
          <RetailCostReview
            page={page}
            setPage={setPage}
            onCountChange={() => setCostReviewRefetch((prev) => prev + 1)}
          />
        ) : tabId == 3 ? (
          <RetailRules page={page} setPage={setPage} />
        ) : tabId == 4 ? (
          <ImumTrackingCategories page={page} setPage={setPage} />
        ) : tabId == 5 ? (
          <QueryClientProvider client={queryClient}>
            <RetailStatistics
              perPage={perPage}
              setPerPage={setPerPage}
              page={page}
              setPage={setPage}
              setTotals={setTotals}
              totals={totals}
              setLength={setLength}
            />
          </QueryClientProvider>
        ) : null}
      </div>
      {modal == "category" && (
        <ModalSimple
          text={"Filter by categories"}
          secondButton={() =>
            dispatch(
              onFilterUpdateWithUser([], "user_categories", "categoryFilter")
            )
          }
          secondButtonText="Clear the category filter"
          onClose={() => {
            setModal("");
            dispatch({
              type: "LOADING_RETAIL",
            });
          }}
        >
          <CategoryFilterModal />
        </ModalSimple>
      )}
      {modal == "categories_settings" && (
        <ModalSimple
          text={"Categories settings"}
          style={{ maxWidth: 1000 }}
          onClose={() => {
            setModal("");
            dispatch({
              type: "LOADING_RETAIL",
            });
          }}
        >
          <ModalImumCategorySettings />
        </ModalSimple>
      )}
    </Container>
  );
}

const TopNav = ({ page, setModal }) => {
  const { totals, current, loading, data, show_data } = useSelector(
    (state) => state.retail
  );

  useEffect(() => {
    const key = "updatable";
    if (loading)
      return message.loading({
        content: "Loading...",
        key,
        duration: 0,
        style: {
          bottom: 66,
          position: "absolute",
          top: "unset",
          right: "50%",
        },
      });
    else
      return message.success({
        content: "Loaded!",
        key,
        duration: 2,
        style: {
          bottom: 66,
          position: "absolute",
          top: "unset",
          right: "50%",
        },
      });
  }, [loading]);
  return (
    <ContentBlock>
      <FilterMenu
        page={page}
        totals={totals}
        length={current == "imum_monitorings" ? 1 : data.length}
        loading={loading}
        countPage={
          current == "imum_monitorings"
            ? null
            : current == "imum_rules"
              ? DEFAULT_IMUM_RULES_PER_PAGE
              : DEFAULT_IMUM_PER_PAGE
        }
        text2={
          current == "imum_monitorings"
            ? "Categories"
            : current == "imum_rules"
              ? "Rules"
              : "Products"
        }
        iconComponent={
          <IconCloudSync className="mr-2" width={28} height={22} />
        }
      // categoryFilterModal={
      //   ["imum_rules", "imum_monitorings"].includes(current)
      //     ? null
      //     : {
      //       openModal: () => setModal("category"),
      //     }
      // }
      // custom={
      //   ["imum_rules", "imum_monitorings"].includes(current) ? null : (
      //     <div>
      //       <span className="filterMenuText">
      //         Categories
      //         <span
      //           className="underline"
      //           style={{ cursor: "pointer" }}
      //           onClick={() => setModal("categories_settings")}
      //         >
      //           {" "}
      //           settings
      //         </span>
      //       </span>
      //     </div>
      //   )
      // }
      >
        {/* {!["imum_rules", "imum_monitorings"].includes(current) && (
          <PullDataFromAkeneo
            data={show_data?.last_sync}
            dataPriority={show_data?.last_sync_priority}
            progress={show_data?.progress}
            progressPriority={show_data?.progress_priority}
          />
        )} */}
      </FilterMenu>
    </ContentBlock>
  );
};

const PullDataFromAkeneo = ({ data, progress, dataPriority, progressPriority }) => {
  const now_syncing = useMemo(() => {
    return !data && progress >= 0
      ? "" + progress + "%"
      : data;
  }, [data, progress]);
  const now_syncing_priority = useMemo(() => {
    return !dataPriority && progressPriority >= 0
      ? "" + progressPriority + "%"
      : dataPriority;
  }, [dataPriority, progressPriority]);
  return (
    <div className="d-flex flex-row">
      <div className="d-flex">
        <div className="d-flex align-items-center mr-2">
          <IconRefresh fill="#03B0F7" width={25} height={25} />
        </div>
        <div>
          <div className="text-sm">Last sync: {now_syncing || "-"}</div>
        </div>
      </div>
      <div className="d-flex ml-2">
        <div className="d-flex align-items-center mr-2">
          <IconRefresh fill="#03B0F7" width={25} height={25} />
        </div>
        <div>
          <div className="text-sm">
            Last sync priority: {now_syncing_priority || "-"}
          </div>
        </div>
      </div>
    </div>
  );
};

// Same badge as NotExportedLabel, but for any counting endpoint. refetchKey lets the tab body ask
// for a fresh count right after a decision instead of waiting for the 30s poll.
const CountedLabel = ({ active, title, url, refetchKey }) => {
  const { value, setReFetch } = useFetch(url, {}, []);

  useInterval(() => {
    setReFetch();
  }, 1000 * 30);

  useEffect(() => {
    if (refetchKey) setReFetch();
  }, [refetchKey]);

  return (
    <div className="d-flex align-items-center justify-content-center">
      {title}
      <div
        className="text-xs text-center ml-1"
        style={{
          backgroundColor: active ? "#E6F7FF" : "#E0E0E0",
          color: active ? "#03B0F7" : "#00000073",
          padding: "0px 9px",
          borderRadius: 100,
        }}
      >
        {value || 0}
      </div>
    </div>
  );
};

const NotExportedLabel = ({ active, title = "Not exported items" }) => {
  const { value, setReFetch } = useFetch(
    `/api/v1/retail_products/total_not_exported`,
    {},
    []
  );

  useInterval(() => {
    setReFetch();
  }, 1000 * 30);

  return (
    <div className="d-flex align-items-center justify-content-center">
      {title}
      <div
        className="text-xs text-center ml-1"
        style={{
          backgroundColor: active ? "#E6F7FF" : "#E0E0E0",
          color: active ? "#03B0F7" : "#00000073",
          padding: "0px 9px",
          borderRadius: 100,
        }}
      >
        {value || 0}
      </div>
    </div>
  );
};
